var name = "@zooplus/samples-component";
var version = "1.2.0";
var license = "UNLICENSED";
var description = "Samples component";
var homepage = ".";
var author = "@MadDragons";
var main = "dist/cjs/index.js";
var types = "dist/es/index.d.ts";
var module = "dist/es/index.js";
var files = [
	"README.md",
	"dist/es",
	"dist/cjs"
];
var peerDependencies = {
	"@sentry/browser": ">=6.19.7",
	"@zooplus/commons-lang": ">=2.0.5",
	"@zooplus/icons": ">=2.0.1",
	"@zooplus/ui-components": ">=6.10.8",
	axios: "^0.21.4",
	"events-bus": "1.0.1",
	i18next: ">=21.5.6",
	react: ">=17.0.2",
	"react-dom": ">=17.0.2",
	"react-error-boundary": ">=3.1.3",
	"react-i18next": ">=11.15.6"
};
var devDependencies = {
	"@babel/preset-env": "^7.23.9",
	"@babel/preset-react": "^7.23.3",
	"@babel/preset-typescript": "^7.23.3",
	"@openapitools/openapi-generator-cli": "^2.9.0",
	"@sentry/browser": "7.99.0",
	"@sentry/types": "7.99.0",
	"@storybook/addon-essentials": "^7.6.17",
	"@storybook/addon-interactions": "^7.6.17",
	"@storybook/addon-links": "^7.6.17",
	"@storybook/blocks": "^7.6.17",
	"@storybook/preset-scss": "^1.0.3",
	"@storybook/react": "^7.6.17",
	"@storybook/react-webpack5": "^7.6.17",
	"@storybook/testing-library": "^0.2.2",
	"@testing-library/dom": "^9.3.4",
	"@testing-library/jest-dom": "^6.4.1",
	"@testing-library/react": "^14.2.1",
	"@testing-library/user-event": "^14.5.2",
	"@types/jest": "^29.5.12",
	"@types/jest-axe": "^3.5.9",
	"@types/node": "^20.11.16",
	"@types/react": "^18.2.51",
	"@types/react-dom": "^18.2.18",
	"@zooplus/commons-lang": "^3.0.5",
	"@zooplus/frontend-configs": "^3.1.0",
	"@zooplus/frontend-scripts": "^6.0.7",
	"@zooplus/icons": "^2.3.0",
	"@zooplus/ui-components": "^6.14.1",
	axios: "^0.21.4",
	classnames: "^2.5.1",
	concurrently: "^8.2.2",
	"eslint-plugin-storybook": "^0.6.15",
	"events-bus": "1.0.1",
	express: "^4.18.1",
	"http-proxy-middleware": "^2.0.6",
	i18next: "23.8.2",
	"i18next-http-backend": "2.4.3",
	jest: "^29.7.0",
	"jest-axe": "^8.0.0",
	"jest-css-modules": "^2.1.0",
	"jest-environment-jsdom": "^29.7.0",
	"jest-environment-node": "^29.7.0",
	"jest-expect-message": "^1.1.3",
	jsdom: "^24.0.0",
	msw: "^0.47.3",
	react: "^18.2.0",
	"react-dom": "^18.2.0",
	"react-error-boundary": "^4.0.12",
	"react-i18next": "14.0.1",
	"rollup-plugin-cleanup": "^3.2.1",
	"rollup-plugin-dev": "^2.0.4",
	storybook: "^7.6.12",
	"storybook-addon-paddings": "^5.0.1",
	"storybook-addon-themes": "^6.1.0",
	"ts-jest": "^29.1.2",
	tslib: "^2.6.2",
	typescript: "5.3.3"
};
var scripts = {
	start: "concurrently \"npm run typecheck\" \"npm run dev\"",
	dev: "rollup -c -w",
	build: "rollup -c",
	storybook: "storybook dev -p 6006",
	"build-storybook": "storybook build",
	lint: "eslint \"**/*.{ts,tsx,js,jsx,cjs}\"",
	"lint:fix": "eslint \"**/*.{ts,tsx,js,jsx,cjs}\" --fix",
	test: "jest",
	"test:ci": "jest --runInBand",
	typecheck: "tsc --noEmit --watch --preserveWatchOutput --pretty",
	"test:analyze-memory": "node --inspect-brk --expose-gc ./node_modules/.bin/jest --runInBand --logHeapUsage",
	"extract-translations": "frontend-scripts extract-translations --keysfrom=public/locales/zu.json --to=public/locales",
	"gen:api": "openapi-generator-cli generate -g typescript-axios --skip-validate-spec -i https://recommendation-api-dev.private.zooplus.net/swagger.json -o ./src/api/recommendation-api/generated",
	format: "prettier --write 'src/**/*.{js,jsx,ts,tsx,json,css,md}'"
};
var engines = {
	node: ">=20.8"
};
var packageInfo = {
	name: name,
	version: version,
	license: license,
	description: description,
	homepage: homepage,
	author: author,
	main: main,
	types: types,
	module: module,
	"jsnext:main": "dist/es/index.js",
	files: files,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	scripts: scripts,
	engines: engines
};

export { author, packageInfo as default, description, devDependencies, engines, files, homepage, license, main, module, name, peerDependencies, scripts, types, version };
//# sourceMappingURL=package.json.js.map
